import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { orderNameConfig } from './Order.name';

enum Order {
  asc = '1',
  desc = '2',
}

const orderMap = new Map([
  ['1', Order.asc],
  ['2', Order.desc],
]);

const rawValueToOrder = rawValueToEnumWithDefault(orderMap, Order.asc);

const orderToDisplay = enumToNameWithDefault(Order, orderNameConfig);

const orderToDisplayWithPrefix = enumToNameWithDefault(Order, orderNameConfig, true);

export { Order, orderToDisplay, orderToDisplayWithPrefix, rawValueToOrder };
